<template>
  <div class="container">
    <h1 class="py-4">おたすけ返済実施明細データ詳細</h1>
    <div v-if="show" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">精算ID</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.settlement_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">立替ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <router-link
                  :to="{
                    name: 'OtasukeForecastDetails',
                    query: { advanceId: data.advance_id },
                  }"
                  >{{ data.advance_id }}</router-link
                >
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_id }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算手段</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_method }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算実行結果</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_execution_result_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_amount }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算元金</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_capital }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">精算手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_fee }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth ht100 flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">予備</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.other }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import sex from "@/constants/SexEnum";
import countries from "@/constants/CountriesEnum";
import prefs from "@/constants/PrefsEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "OtasukeRepaymentDetails",
  mixins: [utils, master, sex, countries, prefs],
  data() {
    return {
      settlementId: "",
      show: false,
      loading: true,
      db: firebase.firestore(),
    };
  },
  created: function() {
    this.settlementId = this.$route.query.settlementId.toString();
    this.loadData();
  },
  methods: {
    init() {
      this.show = false;
      this.key = this.key ? 0 : 1;
    },
    async loadData() {
      this.init();
      const doc = await this.db
        .collection("otasukeRepayment")
        .doc(this.settlementId)
        .get();
      if (doc.exists) {
        this.data = doc.data();
        this.data.settlement_method = this.settlementMethodOptions.find((e) => {
          return e.value == this.data.settlement_method;
        }).display;
        this.show = true;
        this.loading = false;
      }
    },
  },
};
</script>
